export const BACKEND_BASE_URL = process.env.VUE_APP_SVC_BACKEND_BASE_URL as string;

export interface IResponse<T> {
  content: T[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: IPageable;
  size: number;
  sort: ISort;
  totalElements: number;
  totalPages: number;
}

export interface IPageable {
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  sort: ISort;
  unpaged: boolean;
}

export interface ISort {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
}

export enum EDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export interface IPaged {
  direction?: EDirection;
  orderBy?: string;
  page?: number;
  size?: number;
  totalElements?: number;
}
